import type { SxProps, Theme } from '@mui/material';

/** Flatten MUI `sx` values for array composition (MUI's SxProps is not spread-safe). */
export function composeSx(...parts: Array<SxProps<Theme> | undefined>): SxProps<Theme> {
  const out: unknown[] = [];
  for (const part of parts) {
    if (part == null) continue;
    if (Array.isArray(part)) out.push(...(part as unknown[]));
    else out.push(part);
  }
  return out as SxProps<Theme>;
}
